import {
  QUERY_TOTE_CART,
  MUTATION_ADD_TO_TOTE_CART,
  MUTATION_REMOVE_FROM_TOTE_CART,
  MUTATION_ADD_TOTE_CART_SLOT,
  MUTATION_REMOVE_TOTE_CART_SLOT,
  MUTATION_TOTE_CART_CHECKOUT,
  MUTATION_REPLACE_FOR_TOTE_CART,
  QUERY_PREVIEW_TOTE_PREMIUM_SERVICE_FEE,
  QUERY_EXPRESS,
  QUERY_EXPRESS_DURATION,
  MUTATION_CANCEL_ORDER,
  QUERY_PLACE_ORDER,
  QUERY_NEEDS_PAYMENT_TOTE_PREMIUM_SERVICE
} from 'src/app/queries/queries'

// 购物车数据
const queryToteCart = (success, error) => ({
  type: 'API:QUERY_TOTE_CART',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: QUERY_TOTE_CART
  },
  success,
  error
})

// 加入购物车
const addToToteCart = (input, success, error) => ({
  type: 'API:ADD_TO_TOTE_CART',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: MUTATION_ADD_TO_TOTE_CART,
    variables: { input }
  },
  success,
  error
})

// 移出购物车
const removeFromToteCart = (id, success, error) => ({
  type: 'API:REMOVE_FROM_TOTE_CART',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: MUTATION_REMOVE_FROM_TOTE_CART,
    variables: {
      input: {
        product_size_id: id
      }
    }
  },
  success,
  error
})

// 替换购物车内商品
const replaceForToteCart = (input, success, error) => ({
  type: 'API:REPLACE_FOR_TOTE_CART',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: MUTATION_REPLACE_FOR_TOTE_CART,
    variables: { input: input }
  },
  success,
  error
})

// 给购物车加衣位
const addToteCartSlot = (type, success, error) => ({
  type: 'API:ADD_TOTE_CART_SLOT',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: { query: MUTATION_ADD_TOTE_CART_SLOT, variables: { input: { type } } },
  success,
  error
})

// 给购物车删衣位
const removeToteCartSlot = (type, success, error) => ({
  type: 'API:REMOVE_TOTE_CART_SLOT',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: MUTATION_REMOVE_TOTE_CART_SLOT,
    variables: { input: { type } }
  },
  success,
  error
})

// 下单结算详情
const queryToteCartCheckoutPreview = (input, success, error) => ({
  type: 'API:TOTE_CART_CHECKOUT_PREVIEW',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: QUERY_PREVIEW_TOTE_PREMIUM_SERVICE_FEE,
    variables: input
  },
  success,
  error
})

//查询快递公司列表
const queryExpressCompany = (input, success, error) => ({
  type: 'API:TOTE_CART_EXPRESS_COMPANY',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: QUERY_EXPRESS,
    variables: input
  },
  success,
  error
})

//查询快递时间
const queryExpressCompanyDuration = (input, success, error) => ({
  type: 'API:TOTE_CART_EXPRESS_DURATION',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: QUERY_EXPRESS_DURATION,
    variables: input
  },
  success,
  error
})

const toteCartCheckout = (input, success, error) => ({
  type: 'API:TOTE_CART_CHECKOUT',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: MUTATION_TOTE_CART_CHECKOUT,
    variables: { input }
  },
  success,
  error
})

// 取消下单
const cancelToteCartOrder = (input, success, error) => ({
  type: 'API:CANCEL_TOTE_TART_ORDER',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: MUTATION_CANCEL_ORDER,
    variables: { input }
  },
  success,
  error
})

// 下单结果查询
const queryPlaceOrder = (id, success, error) => ({
  type: 'API:PLACE_ORDER',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: QUERY_PLACE_ORDER,
    variables: { id }
  },
  success,
  error
})

// 查询是否有下单的未付款
const queryMeedsPaymentTotePremiumService = (success, error) => ({
  type: 'API:NEEDS_PAYMENT_TOTE_PREMIUM_SERVICE',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: QUERY_NEEDS_PAYMENT_TOTE_PREMIUM_SERVICE
  },
  success,
  error
})

export default {
  queryToteCart,
  queryToteCartCheckoutPreview,
  addToToteCart,
  removeFromToteCart,
  addToteCartSlot,
  removeToteCartSlot,
  replaceForToteCart,
  toteCartCheckout,
  cancelToteCartOrder,
  queryPlaceOrder,
  queryMeedsPaymentTotePremiumService,
  queryExpressCompanyDuration,
  queryExpressCompany
}
